export interface Service {
  id: string;
  name: string;
  availableDays: string[];
  availableProviders: SupportProvider[];
}

export interface TimeSlot {
  time: string;
  isBooked: boolean;
}

export interface DaySchedule {
  day: string;
  morning: TimeSlot[];
  afternoon: TimeSlot[];
  isOpen: boolean;
}

export type AttendanceStatus = 'Pending' | 'Confirmed' | 'Missed';
export type SupportProvider = 'כללית' | 'מכבי' | 'מאוחדת' | 'לאומית' | 'פרטי';

export interface Appointment {
  id: string;
  patientName: string;
  time: string;
  date: string;
  service: string;
  idCard: string;
  village: string;
  phoneNumber: string;
  attendanceStatus: AttendanceStatus;
  supportProvider: SupportProvider;
  isSynced?: boolean;
  clinicName?: string;
  createdBy?: string;
  createdAt?: string;
  isReserveSlot?: boolean;
  status?: string; // 'completed' | 'closed' | 'cancelled' | 'draft'
  confirmationStatus?: string; // 'pending' | 'confirmed' | 'cancelled'
  reminderSent?: boolean;
}

export interface Holiday {
  id: string;
  date: string;
  description?: string;
}

export type View = 'reminderHistory' | 'dashboard' | 'appointmentsSummary' | 'services' | 'schedule' | 'holidays' | 'booking' | 'drafts' | 'reports' | 'technicians';

export interface WeekDay {
  id: string;  // English name for API
  label: string;  // Hebrew name for display
}

export const WEEK_DAYS: WeekDay[] = [
  { id: 'Sunday', label: 'ראשון' },
  { id: 'Monday', label: 'שני' },
  { id: 'Tuesday', label: 'שלישי' },
  { id: 'Wednesday', label: 'רביעי' },
  { id: 'Thursday', label: 'חמישי' },
  { id: 'Friday', label: 'שישי' },
  { id: 'Saturday', label: 'שבת' },
];